import AuthService from 'common/auth.service';
import Breadcrumbs from 'components/Common/Breadcrumb';
import Paginate from 'components/Paginate';
import TableError from 'components/TableError';
import { useFormik } from 'formik';
import { useRouter } from 'hooks/useRouter';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Badge, Card, CardBody, Col, Container, Form, Label, Row, Table } from 'reactstrap';
import { ACTIVE_AND_DELETED_ARRAY, SORT_VALUES } from 'utils/constants';
import { checkIfValueExist, printDateTimeTwoLines } from 'utils/helper';
import Loader from '../../../../components/Loader';
import useRequest from '../../../../hooks/useRequest';

const PageviewList = () => {
  const router = useRouter();
  const history = useHistory();
  toast.configure();

  const auth = new AuthService();
  const source = auth.getAppSourceCookie();

  const [pageviewPagination, setpageviewPagination] = useState({});
  const [pageviewList, setpageviewList] = useState();

  const [pageviewListRequest, { loading: pageviewListLoading }] = useRequest({
    method: 'POST',
    url: `/common/pageView/admin/search`,
    onSuccess: (data) => {
      setpageviewList(data?.results);
      setpageviewPagination(data?.pagination);
    },
  });

  const setPageInUrl = (page) => {
    history.push({
      pathname: router.pathname,
      search: `?${new URLSearchParams({ page }).toString()}`,
    });
  };

  const handleChangePage = (page) => {
    setPageInUrl(page);

    pageviewListRequest({
      body: {
        page: page,
        size: 50,
        source,
        ...SORT_VALUES,
      },
    });
  };

  const applyFilters = (obj) => {
    setPageInUrl(1);

    pageviewListRequest({
      body: {
        page: 1,
        size: 50,
        source,
        ...SORT_VALUES,
        active: checkIfValueExist(obj?.active?.value),
        deleted: checkIfValueExist(obj?.deleted?.value),
      },
    });
  };

  const formik = useFormik({
    initialValues: {
      active: { value: null, label: 'All' },
      deleted: { value: null, label: 'All' },
    },
    onSubmit: (values) => {
      applyFilters(values);
    },
  });

  const clearFilters = () => {
    setPageInUrl(1);
    formik.resetForm();

    pageviewListRequest({
      body: {
        page: 1,
        size: 20,
        source,
        ...SORT_VALUES,
      },
    });
  };

  useEffect(() => {
    handleChangePage(parseInt(router?.query?.page, 10) || 1);
  }, []);

  return (
    <>
      <div className="page-content">
        <Loader isActive={pageviewListLoading} />
        <Container fluid>
          <Breadcrumbs title="Pageview" breadcrumbItem="Pageview List" />
          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <div className="mt-4">
                  <div className="row" style={{ gap: '20px' }}>
                    <div className="col-lg-2">
                      <Label className="form-label">Active</Label>
                      <Select
                        options={ACTIVE_AND_DELETED_ARRAY}
                        value={formik?.values?.active}
                        onChange={(active) => formik.setFieldValue('active', active)}
                      />
                    </div>

                    <div className="col-lg-2">
                      <Label className="form-label">Deleted</Label>
                      <Select
                        options={ACTIVE_AND_DELETED_ARRAY}
                        value={formik?.values?.deleted}
                        onChange={(deleted) => formik.setFieldValue('deleted', deleted)}
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-4">
                  <button className="btn btn-primary me-4" type="submit">
                    Apply Filters
                  </button>
                  <a className="" type="reset" onClick={clearFilters}>
                    Clear
                  </a>
                </div>
              </Form>
            </CardBody>
          </Card>

          <Row className="mb-2  align-items-center">
            <Col sm="4">
              <div className="search-box me-2 mb-2">
                <div className="position-relative font-bold">{pageviewPagination?.totalCount} Pageview Found</div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg="12">
              <div className="">
                <div className="table-responsive" style={{ minHeight: 300 }}>
                  <Table className="project-list-table table-borderless">
                    <thead>
                      <tr className="table-warning">
                        <th scope="col">ID</th>
                        <th scope="col">Source</th>
                        <th scope="col">URL</th>
                        <th scope="col">utm_campaign</th>
                        <th scope="col">utm_medium</th>
                        <th scope="col">utm_campaign</th>
                        {/* <th scope="col">Country</th> */}
                        {/* <th scope="col">State</th> */}
                        {/* <th scope="col">City</th> */}
                        {/* <th scope="col">Postal</th> */}
                        {/* <th scope="col">Ipv4</th> */}
                        <th scope="col">Created Date</th>
                        <th scope="col">Active</th>
                        <th scope="col">Deleted</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(pageviewList) ? (
                        pageviewList?.map((data, index) => (
                          <tr key={index}>
                            <td>{data?.id}</td>
                            <td>{data?.source}</td>
                            <td>{data?.url}</td>
                            <td>{data?.utm_campaign}</td>
                            <td>{data?.utm_medium}</td>
                            <td>{data?.utm_campaign}</td>
                            {/* <td>
                              {!isEmpty(data?.location?.countryName)
                                ? data?.location?.countryName + `(${data?.location?.countryCode})`
                                : ''}
                            </td>
                            <td>{data?.location?.state}</td>
                            <td>{data?.location?.city}</td>
                            <td>{data?.location?.postal}</td>
                            <td>{data?.location?.ipv4}</td> */}
                            <td>{printDateTimeTwoLines(data?.createdDate)}</td>
                            <td>
                              <Badge className={data?.active ? 'bg-success' : 'bg-danger'}>
                                {data?.active ? 'Yes' : 'No'}
                              </Badge>
                            </td>
                            <td>
                              <Badge className={data?.deleted ? 'bg-success' : 'bg-danger'}>
                                {data?.deleted ? 'Yes' : 'No'}
                              </Badge>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <TableError />
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Col>
          </Row>

          <Paginate pageInfo={pageviewPagination} onChangePage={handleChangePage} />
        </Container>
      </div>
    </>
  );
};

export default PageviewList;
